import React, { useContext } from "react";
import { Auth } from "../Contexts/AuthContext";

const useAuthContext = () => {
  return useContext(Auth);
};

export default useAuthContext;
